"use client";
import React, { useEffect, useRef, useState } from "react";
import { Container, Box, Skeleton, HStack } from "@chakra-ui/react";
import Script from "next/script";
import { isBrowser } from "@/utils/helpers";

declare global {
  interface Window {
    Trustpilot: any;
  }
}

const TrustPilotEmbed = () => {
  const ref = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (isBrowser() && window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
      // Give the widget a moment to render, then hide skeleton
      setTimeout(() => setIsLoaded(true), 1000);
    }
  }, []);

  return (
    <Container maxW="container.xl" mt="63px">
      <Script
        type="text/javascript"
        src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        async
        onLoad={() => {
          if (isBrowser() && window.Trustpilot && ref.current) {
            window.Trustpilot.loadFromElement(ref.current, true);
            setTimeout(() => setIsLoaded(true), 1000);
          }
        }}
      />

      <Box position="relative" minHeight="140px">
        {/* Loading skeleton - matches the carousel height */}
        {!isLoaded && (
          <Box position="absolute" width="100%" height="140px" zIndex={1} bg="transparent">
            <HStack spacing={4} height="100%">
              {[1, 2, 3].map((i) => (
                <Skeleton
                  key={i}
                  height="140px"
                  flex="1"
                  borderRadius="8px"
                  startColor="gray.100"
                  endColor="gray.200"
                  speed={1.2}
                />
              ))}
            </HStack>
          </Box>
        )}

        <div
          ref={ref}
          className="trustpilot-widget"
          data-locale="en-US"
          data-template-id="53aa8912dec7e10d38f59f36"
          data-businessunit-id="6571ea6ee585f90503de1860"
          data-style-height="140px"
          data-style-width="100%"
          data-theme="light"
          data-stars="5"
          data-review-languages="en"
          style={{
            minHeight: "140px",
            opacity: isLoaded ? 1 : 0,
            transition: "opacity 0.3s ease-in-out",
          }}
        >
          <a href="https://www.trustpilot.com/review/example.com" target="_blank" rel="noopener">
            {" "}
            Trustpilot
          </a>
        </div>
      </Box>
    </Container>
  );
};

export default TrustPilotEmbed;
